<template>
  <v-data-table
    :headers="headers"
    :items="filtedUserList"
    sort-by="calories"
    class="elevation-1"
    :loading="!apiDone"
    loading-text="Loading... Please wait"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t(tableTitle.text) }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <div class="w-120-px">
          <v-text-field
            label="Fliter PID"
            hide-details
            v-model="fliter.pid"
          ></v-text-field>
        </div>
        <div class="ml-3">
          <v-text-field
            label="帳號"
            hide-details
            v-model="fliter.loginname"
          ></v-text-field>
        </div>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <!-- <template v-slot:body.append>
      <tr>
        <td colspan="3"></td>
      </tr>
    </template> -->
    <template v-slot:item.actions="{ item }">
      <!-- {{ item.flag }} -->
      <v-btn
        v-if="tableTitle.text === 'MEMBER_MENU_3'"
        small
        plain
        class="mr-3"
        color="primary"
        @click.stop="editItem(item)"
        >編輯</v-btn
      >
      <v-btn
        v-if="[0, 1, 2].includes(item.flag)"
        class="mr-3"
        small
        plain
        color="primary"
        @click.stop="turnOnOff(item)"
      >
        <template v-if="item.flag === 1">停用</template>
        <template v-if="item.flag === 0">啟用</template>
        <template v-if="item.flag === 2">停用</template>
      </v-btn>
      <v-btn small plain color="primary" @click="resetPwd(item)">重置密碼</v-btn>
      <template v-if="item.flag === 2">此帳號待強制改密碼</template>
      <!-- <template small v-if="item.flag === 2">此帳號待強制註冊 OTP</template> -->
      <!-- <v-btn small plain color="danger" @click="resetPwd(item)" >重置驗證碼</v-btn> -->
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="getUsers"> Reset </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'MemberTable',

  inject: ['getUsers', 'switchCreateMemberArea', 'getDefaultPassword'],

  props: ['tableTitle', 'headers', 'userList', 'apiDone'],

  data() {
    return {
      selected: [],
      fliter: {
        pid: '',
        loginname: ''
      }
    }
  },

  computed: {
    filtedUserList() {
      const list = this.userList
      const arr = []
      for (const i in list) {
        const curr = list[i]
        if (
          (!this.fliter.pid ||
            curr.pid.toLowerCase().includes(this.fliter.pid.toLowerCase())) &&
          (this.fliter.loginname === '' ||
            curr.loginname
              .toLowerCase()
              .includes(this.fliter.loginname.toLowerCase()))
        ) {
          arr.push(curr)
        }
      }
      return arr
    }
  },

  methods: {
    ...mapActions('message', ['setSnackbar']),
    ...mapActions('member', ['setEditedData']),
    editItem(item) {
      this.setEditedData(item)
      this.switchCreateMemberArea(true)
    },
    turnOnOff(item) {
      const { loginname } = item
      this.$api.common.user.turnOnOff({ loginname }).then(() => {
        this.getUsers()
      })
    },
    resetPwd(item) {
      const { loginname } = item
      const newPwd = this.getDefaultPassword(8)
      this.$api.common.user
        .resetPwd({ loginname, newPwd })
        .then(() => {
          this.$copyText(newPwd).then(
            (e) => {
              this.setSnackbar({
                show: true,
                text: `重置成功並複製預設密碼 ${newPwd}，請盡速將密碼貼給客戶。(預設密碼無法返查)`,
                timeout: '5000',
                type: 'text'
              })
              console.log(e)
            },
            (e) => {
              console.log(e)
            }
          )
          this.getUsers()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
